import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {$t} from "helpers/translator";
import styles from './SingleReport.module.scss';
import './SingleReport.global.scss';
import api from "helpers/api";
import Loader from "components/miscellaneous/Loader/Loader";
import types from 'components/Reports/Types/ReportTypes';

function SingleReportPage({isStandalone}) {
    const params = useParams();
    const [token, setToken] = useState(null);
    const [report, setReport] = useState(null);
    const [isFullyLoaded, setIsFullyLoaded] = useState(false);

    useEffect(() => {
        if(params.token) {
            setToken(params.token);
        }
    }, [params]);

    useEffect(() => {
        if(token !== null) {
            getReport()
        }
    }, [token]);

    useEffect(() => {
        if(report !== null) {
            new Promise(resolve => setTimeout(resolve, 50)).then(() => {
                setIsFullyLoaded(true);
            });
        } else {
            setIsFullyLoaded(false);
        }
    }, [report]);

    const getReport = async() => {
        const res = await api.get(`/report/${token}`);

        if(res.success) {
            setReport(res.data.data);
        } else {
            // console.log(res);
        }
    }

    const renderReport = () => {
        const getType = types.find(type => type.id === report.type);
        const ReportComponent = getType.component;
        if(ReportComponent) {
            return <div id={isFullyLoaded ? 'reportLoaded' : 'reportNotLoaded'}>
                <ReportComponent isStandalone={isStandalone} report={report} />
            </div>
        } else {
            return <div>Report type is not supported.</div>
        }
    }

    return (
        <div id="reportBody" className={isStandalone ? styles.body : styles.bodyContainer}>
            <div className={styles.container} style={{width: '75%', margin: 'auto', marginTop: 0}}>
                {report ? renderReport() : <Loader color="#ddd" />}
            </div>
        </div>
    )
}

export default SingleReportPage;
